import validator from './validator';

const mixed = {
  required: validator(v => !!v, 'validation.mixed.required'),
  oneOf: (...reference) => {
    if (reference.length === 0) {
      throw new TypeError('reference values cannot be empty');
    }
    return validator(
      v => reference.includes(v),
      'validation.mixed.oneOf',
      reference
    );
  }
};

export default mixed;
